import type * as TrackProcessors from '@livekit/track-processors'
import type { LocalVideoTrack } from 'livekit-client'
import type { BackgroundOption } from './adapter'

// Единственная точка импорта @livekit/track-processors. Модуль (и MediaPipe
// WASM за ним) грузится динамически — вне включённого фона не тянется в бандл.

type ProcessorsModule = typeof TrackProcessors

let modulePromise: Promise<ProcessorsModule> | null = null

function loadProcessors(): Promise<ProcessorsModule> {
  modulePromise ??= import('@livekit/track-processors')
  return modulePromise
}

export async function isBackgroundSupported(): Promise<boolean> {
  try {
    const mod = await loadProcessors()
    return mod.supportsBackgroundProcessors()
  } catch {
    return false
  }
}

export async function applyBackground(
  track: LocalVideoTrack,
  option: BackgroundOption,
): Promise<void> {
  if (option.type === 'none') {
    await track.stopProcessor()
    return
  }

  const mod = await loadProcessors()
  // Слабое железо / нет WebGL: молча остаёмся без фона, звонок не ломаем.
  if (!mod.supportsBackgroundProcessors()) return

  const processor =
    option.type === 'blur'
      ? mod.BackgroundBlur(option.radius ?? 10)
      : mod.VirtualBackground(option.imageUrl)

  await track.setProcessor(processor)
}
